import { UserCanGdprDeleteSelfActionTypes, FetchUserCanGdprDeleteSelf } from '../actions/UserCanGdprDeleteSelfActions';
import { getFetchUserCanGdprDeleteSelfRequestStatus } from '../selectors/RequestStatusSelector';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import UsersAPI from '../api/UsersAPI';
import requestEntity from './requestEntity';
import RequestEpicDescriptor from './RequestEpicDescriptor';
const fetchUserCanGdprDeleteActionSelf = requestEntity(new RequestEpicDescriptor({
  apiFunction: UsersAPI.checkNoAdminlessHubs,
  initiatingActionType: UserCanGdprDeleteSelfActionTypes.LOAD_CAN_GDPR_DELETE_SELF,
  requestStatusSelector: getFetchUserCanGdprDeleteSelfRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED],
  requestActions: FetchUserCanGdprDeleteSelf
}));
export default fetchUserCanGdprDeleteActionSelf;